/**
 * ConnectionSection — client-side connection / desync telemetry (ping,
 * room, close code, message counts). The server-side claimRejects are not
 * readable from the client without the diag endpoint, so we surface what
 * the NetworkTracer exposes.
 */

import React from 'react';
import { Section, Row } from '../RaceDebugPrimitives';

const COLOR = '#ff4444';

export const ConnectionSection: React.FC<{
  nm: any;
  room: any;
  tracer: any;
}> = ({ nm, room, tracer }) => (
  <Section title="Connection" color={COLOR}>
    <Row label="connected" value={nm?.isConnected?.() ? 'YES' : 'NO'}
         valueColor={nm?.isConnected?.() ? '#2ecc71' : '#e74c3c'} />
    <Row label="sessionId" value={room?.sessionId ?? '—'} />
    <Row label="roomId" value={tracer?.firstRoomId ?? '—'} />
    <Row label="ping" value={tracer?.lastPingMs != null && tracer.lastPingMs >= 0
      ? `${tracer.lastPingMs}ms`
      : '—'} />
    <Row label="closeCode" value={nm?.lastCloseCode != null
      ? String(nm.lastCloseCode)
      : '—'} />
    <Row label="msgs sent" value={String(tracer?.messagesSent ?? 0)} />
    <Row label="msgs recv" value={String(tracer?.messagesReceived ?? 0)} />
  </Section>
);
